var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.33 2.66699H4.66334C2.11 2.66699 1.39667 3.28033 1.33667 5.66699C2.62334 5.66699 3.66334 6.71366 3.66334 8.00033C3.66334 9.28699 2.62334 10.327 1.33667 10.3337C1.39667 12.7203 2.11 13.3337 4.66334 13.3337H11.33C13.9967 13.3337 14.6633 12.667 14.6633 10.0003V6.00033C14.6633 3.33366 13.9967 2.66699 11.33 2.66699Z",
    fill: "#DBE2FF",
    stroke: "#4258BF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99554 2.66699V5.00033",
    stroke: "#4258BF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99554 11V13.3333",
    stroke: "#4258BF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0166 6.22043L10.43 7.05376C10.47 7.13376 10.55 7.19376 10.6366 7.2071L11.5566 7.34043C11.7833 7.37376 11.8766 7.65376 11.71 7.81376L11.0433 8.46043C10.9766 8.52043 10.95 8.61376 10.9633 8.7071L11.1233 9.62043C11.1633 9.8471 10.9233 10.0204 10.7233 9.91376L9.9033 9.48043C9.8233 9.44043 9.7233 9.44043 9.6433 9.48043L8.8233 9.91376C8.61664 10.0204 8.3833 9.8471 8.4233 9.62043L8.5833 8.7071C8.59664 8.61376 8.56997 8.5271 8.5033 8.46043L7.8433 7.81376C7.67664 7.65376 7.76997 7.37376 7.99664 7.34043L8.91664 7.2071C9.00997 7.19376 9.0833 7.14043 9.1233 7.05376L9.52997 6.22043C9.6233 6.01376 9.91664 6.01376 10.0166 6.22043Z",
    fill: "#DBE2FF",
    stroke: "#4258BF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.e000709c2e69a51d26c36d2115a202b7.svg";
export { ForwardRef as ReactComponent };